var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"aside-container",class:{ 'menu-closed': !_vm.showMenu }},[_c('Avatar',{attrs:{"url":_vm.icon}}),_c('div',{staticClass:"user"},[_vm._v(_vm._s(_vm.user.name))]),_c('Menu'),_c('Contact'),_c('p',{staticClass:"footer"},[_vm._v("ICP备xxxx号")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }